export enum RegisterRole {
  Manager = 1,
  User = 10,
  Guest = 20,
}
